import { Route, Routes } from "react-router-dom";
import React from "react";
import {
  AddCustomRole,
  Notifications,
  RolesAndPermission,
  TaxInvoices,
  CustomRoleDetail,
  SystemRoleDetail,
  StaffEditor,
  StudentSettings,
  Customize,
  EditLeadForm,
  PurchaseHistory,
  LeadAutomation,
  CreateLeadAutomation,
} from "../pages";
import {
  checkSubDomainAccess,
  getSubDomainAccessStatus,
} from "../components/RolePermissionAccess/RolePermissionAccess";
import { useSelector } from "react-redux";
import NoAccess from "../components/NoAccess/NoAccess";
import CreateLeadAutomationForm from "../pages/app/Settings/components/Automation/LeadManagement/CreateLeadAutomationForm";

export default function ManageSettingsRouter(props: any) {
  const { userById } = useSelector((state: any) => state.userDetails);
  const rolesAccess = checkSubDomainAccess(
    "SETTINGS",
    "ROLES_&_PERMISSIONS",
    userById?.rolePermission
  );
  const taxInvoiceAccess = checkSubDomainAccess(
    "SETTINGS",
    "INVOICES",
    userById?.rolePermission
  );
  const notificationAccess = checkSubDomainAccess(
    "SETTINGS",
    "NOTIFICATIONS",
    userById?.rolePermission
  );
  const teamAccess = checkSubDomainAccess(
    "MANAGE",
    "TEAMS",
    userById?.rolePermission
  );
  const studentIdAccess = checkSubDomainAccess(
    "SETTINGS",
    "STUDENT_ID",
    userById?.rolePermission
  );

  const customizeAccess = checkSubDomainAccess(
    "SETTINGS",
    "CUSTOMIZE",
    userById?.rolePermission
  );

  const EditLeadFormPermission = getSubDomainAccessStatus(
    "SETTINGS",
    "CUSTOMIZE",
    "ALL_ACCESS",
    userById?.rolePermission
  );

  const purchaseHistoryAccess = checkSubDomainAccess(
    "SETTINGS",
    "CUSTOMIZE",
    userById?.rolePermission
  );

  const leadAutomationAccess = checkSubDomainAccess(
    "SETTINGS",
    "LEAD_AUTOMATION",
    userById?.rolePermission
  );

  return (
    <Routes>
      <Route
        path={"/"}
        element={taxInvoiceAccess ? <TaxInvoices /> : <NoAccess />}
      />
      <Route
        path={"/Invoices"}
        element={taxInvoiceAccess ? <TaxInvoices /> : <NoAccess />}
      />
      <Route
        path={"/Notifications"}
        element={notificationAccess ? <Notifications /> : <NoAccess />}
      />
      <Route
        path={"/Rolesandpermission"}
        element={rolesAccess ? <RolesAndPermission /> : <NoAccess />}
      />
      <Route
        path={"/Rolesandpermission/SystemRoleDetails/:id"}
        element={rolesAccess ? <SystemRoleDetail /> : <NoAccess />}
      />
      <Route
        path={"/Rolesandpermission/CustomRoleDetails/:id"}
        element={rolesAccess ? <CustomRoleDetail /> : <NoAccess />}
      />
      <Route
        path={"/Rolesandpermission/AddCustomRole"}
        element={rolesAccess ? <AddCustomRole /> : <NoAccess />}
      />
      <Route
        path={"/Rolesandpermission/AddCustomRole"}
        element={rolesAccess ? <AddCustomRole /> : <NoAccess />}
      />
      <Route
        path={"/Rolesandpermission/Create-Team"}
        element={
          teamAccess ? <StaffEditor add={true} backBtn={true} /> : <NoAccess />
        }
      />
      <Route
        path={"/Student"}
        element={studentIdAccess ? <StudentSettings /> : <NoAccess />}
      />
      <Route
        path={"/Customize"}
        element={customizeAccess ? <Customize /> : <NoAccess />}
      />

      <Route
        path={"/Customize/CreateLeadForm"}
        element={
          EditLeadFormPermission ? <EditLeadForm add={true} /> : <NoAccess />
        }
      />
      <Route
        path={"/Customize/EditLeadForm/:id"}
        element={
          EditLeadFormPermission ? <EditLeadForm add={false} /> : <NoAccess />
        }
      />
      <Route
        path={"/PurchaseHistory"}
        element={purchaseHistoryAccess ? <PurchaseHistory /> : <NoAccess />}
      />
      <Route
        path={"/LeadAutomation"}
        element={leadAutomationAccess ? <LeadAutomation /> : <NoAccess />}
      />
      <Route
        path={"/LeadAutomation/CreateLeadAutomationForm"}
        element={
          leadAutomationAccess ? (
            <CreateLeadAutomation add={true} />
          ) : (
            <NoAccess />
          )
        }
      />
      <Route
        path={"/LeadAutomation/EditLeadAutomationForm"}
        element={
          leadAutomationAccess ? (
            <CreateLeadAutomation add={false} />
          ) : (
            <NoAccess />
          )
        }
      />
    </Routes>
  );
}
